import Decimal from 'decimal.js';

type OtcAvailabilityReason = 'below_minimum_amount';

export interface OtcAvailability {
  available: boolean;
  reason?: OtcAvailabilityReason;
  minOtcAmount?: string;
}

interface CheckOtcAvailabilityParams {
  amount: string;
  minOtcTransactionLimit: string;
}

export function checkOtcAvailability({
  amount,
  minOtcTransactionLimit,
}: CheckOtcAvailabilityParams): OtcAvailability {
  const amountNum = new Decimal(amount ? amount : 0);
  const minOtcNum = new Decimal(minOtcTransactionLimit);

  // OTC is available only when amount meets or exceeds the minimum OTC limit
  if (amountNum.lt(minOtcNum)) {
    return {
      available: false,
      reason: 'below_minimum_amount',
      minOtcAmount: minOtcTransactionLimit,
    };
  }

  return {
    available: true,
  };
}
